export const Info = {
  isBrioSku: {
    // eslint-disable-next-line id-length
    read(_, _ref) {
      let {
        readField
      } = _ref;
      const productSubType = readField('productSubType');
      return !!((productSubType === null || productSubType === void 0 ? void 0 : productSubType.name) === 'SFI');
    }
  },
  isCustomKitchenCabinet: {
    // eslint-disable-next-line id-length
    read(_, _ref2) {
      let {
        readField
      } = _ref2;
      const productSubType = readField('productSubType');
      const categoryHierarchy = readField('categoryHierarchy');
      return !!((productSubType === null || productSubType === void 0 ? void 0 : productSubType.name) === 'SFI' && categoryHierarchy !== null && categoryHierarchy !== void 0 && categoryHierarchy.find(category => category === 'Custom Kitchen Cabinets'));
    }
  }
};
//# sourceMappingURL=Info.js.map